var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapMarkerFilled = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.601 5.01C1.601 9.025 6 11.5 6 11.5s4.399-2.475 4.399-6.49A4.402 4.402 0 0 0 4.29.845 4.399 4.399 0 0 0 1.6 5.01ZM6 6.4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
  fill: "#121318"
})));
export default SvgMapMarkerFilled;